module.exports = __webpack_public_path__ + "img/Sign_3.b5a7a0aa.png";